import React from "react";

/**
 * Service card — design/card.png
 *   normal : white card, orange icon, label bar #BDBDBD (64px) at the bottom
 *   hover  : label bar turns solid #4B4F55
 *   active : the bar grows over the whole card (#4B4F55 at 80%), icon shows
 *            through it and the label sits in the middle of the card
 */
export default function ImageCircle(props) {
  const text =
    props.lang === "th" ? props.item.link.label_TH : props.item.link.label_EN;

  return (
    <div className="group relative w-full h-[220px] rounded-[12px] overflow-hidden bg-white border-[1px] border-cardBorder cursor-pointer select-none">
      {/* Icon */}
      <div className="h-[164px] flex items-center justify-center px-[20px]">
        {props.item.icon && (
          <img
            className="max-h-[88px] max-w-[110px] object-contain"
            src={`${process.env.REACT_APP_API_URL}${props.item.icon.url}`}
            alt=""
          />
        )}
      </div>

      {/* Label bar — grows to cover the card while pressed */}
      {/* ป้ายทุกใบใช้ขนาดเดียวกัน (เท่าป้ายยาวอย่าง "การอบรมปฐมพยาบาลเบื้องต้น") */}
      <div className="absolute inset-x-0 bottom-0 min-h-[56px] py-[6px] group-active:h-full bg-labelGray group-hover:bg-slateGray group-active:bg-slateGray/80 flex items-center justify-center px-[12px] transition-all duration-300 ease-in-out">
        <h1 className="text-white text-lead font-normal text-center !leading-none line-clamp-2">
          {text}
        </h1>
      </div>
    </div>
  );
}
